import { render, staticRenderFns } from "./MydetailsOCRModal.vue?vue&type=template&id=12e83ecc&scoped=true"
import script from "./MydetailsOCRModal.vue?vue&type=script&lang=js"
export * from "./MydetailsOCRModal.vue?vue&type=script&lang=js"
import style0 from "./MydetailsOCRModal.vue?vue&type=style&index=0&id=12e83ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e83ecc",
  null
  
)

export default component.exports